import React from 'react';
import PanelistInfo from '../PanelistInfo/PanelistInfo';

const Panelist = ({ data }) => {
  const { photo } = data;
  return (
    <div className="panelists__inner">
      <img src={photo} alt="" />
      <PanelistInfo data={data} />
    </div>
  );
};

export default Panelist;
